import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, emailCopyVariant, socialIconHover } from '../../animations/animations';
import { MdEmail, MdContentCopy, MdCheck } from 'react-icons/md';
import { FaLinkedinIn, FaGithub } from 'react-icons/fa';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const email = 'suhas@suhasp.dev';

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <section id="contact" className="py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold gradient-text mb-4">
            Ready to Engineer Solutions?
          </h2>
          <p className="text-xl text-textSecondary mb-12">
            Embedded Linux, firmware reliability, BSP bring-up, or secure OTA - if the problem lives close to the hardware, I want to hear about it.
          </p>
        </motion.div>

        {/* Email Copy Button */}
        <motion.div
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="mb-12"
          data-aos="zoom-in-up"
        >
          <p className="text-textSecondary mb-4">Click to copy email address</p>

          <motion.button
            variants={emailCopyVariant}
            initial="initial"
            whileHover="hover"
            whileTap="tap"
            onClick={handleCopyEmail}
            className="relative inline-flex items-center gap-4 px-8 py-4 bg-white/5 border border-white/20 rounded-xl hover:border-primary/50 hover:bg-primary/5 transition-all group overflow-hidden"
          >
            {/* Water animation on hover */}
            <span className="absolute inset-0 bg-gradient-to-r from-primary/20 to-primaryLight/20 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500" />

            <MdEmail className="w-6 h-6 text-primaryLight relative z-10" />
            <span className="text-lg text-textPrimary font-medium relative z-10">{email}</span>

            <span className="relative z-10 ml-2 p-2 bg-primary rounded-lg">
              {copied ? (
                <MdCheck className="w-5 h-5 text-white" />
              ) : (
                <MdContentCopy className="w-5 h-5 text-white" />
              )}
            </span>
          </motion.button>

          {copied && (
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="text-success mt-3 text-sm"
            >
              Copied to clipboard!
            </motion.p>
          )}
        </motion.div>

        {/* Social Links */}
        <motion.div
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="mb-12"
        >
          <p className="text-textSecondary mb-6">Connect with me</p>

          <div className="flex justify-center gap-4">
            <motion.a
              href="https://www.linkedin.com/in/siddu-suhas/"
              target="_blank"
              rel="noopener noreferrer"
              variants={socialIconHover}
              initial="rest"
              whileHover="hover"
              className="w-14 h-14 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center transition-all duration-300 hover:border-blue-500 hover:bg-blue-500/10 group"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn className="w-6 h-6 text-textSecondary group-hover:text-blue-500 transition-colors" />
            </motion.a>

            <motion.a
              href="https://github.com/siddusuhaas"
              target="_blank"
              rel="noopener noreferrer"
              variants={socialIconHover}
              initial="rest"
              whileHover="hover"
              className="w-14 h-14 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center transition-all duration-300 hover:border-gray-400 hover:bg-gray-500/10 group"
              aria-label="GitHub"
            >
              <FaGithub className="w-6 h-6 text-textSecondary group-hover:text-gray-300 transition-colors" />
            </motion.a>
          </div>
        </motion.div>

        {/* Divider Quote */}
        <motion.div
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="py-8 border-t border-white/10"
        >
          <blockquote className="text-textMuted italic text-lg max-w-2xl mx-auto">
            "A complex system that works is invariably found to have evolved from a simple system that worked."
          </blockquote>
          <p className="text-textMuted text-sm mt-2">- John Gall</p>
        </motion.div>

        {/* Footer */}
        <motion.p
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="text-textMuted text-sm"
        >
          © 2026 Suhas P. Embedded Linux &amp; Firmware Engineer.
        </motion.p>
      </div>
    </section>
  );
};

export default Contact;
